import React from "react";

import * as S from "./styles";

export const Slide3: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Title>coração aberto</S.Title>
        <S.Text>
          Sem medo de si ou do mundo, Luísa Sonza prova para todos que tem a
          singular combinação de vulnerabilidade e força que a posição de
          estrela pop exige.
        </S.Text>
      </S.Wrapper>
    </S.Container>
  );
};
